import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TaskService } from 'src/app/modules/instance/services';
import { ISchedulerSettings } from 'src/app/modules/scheduler/interfaces/scheduler-settings.interface';
import { SchedulerSettingsService } from 'src/app/modules/scheduler/services/scheduler-settings.service';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';

@Component({
    standalone: false,
    selector: 'app-prs-bunch-size-slider',
    templateUrl: './prs-bunch-size-slider.component.html',
    styleUrls: ['./prs-bunch-size-slider.component.scss']
})
export class PrsBunchSizeSliderComponent implements OnInit, OnDestroy {
    @Input()
    task: ITaskModel;

    isSpinnerVisible: boolean = false;

    schedulerSettings: ISchedulerSettings;

    private destroy$ = new Subject<boolean>();

    constructor(
        private readonly taskService: TaskService,
        private readonly schedulerSettingsService: SchedulerSettingsService
    ) {}

    get maxPRsBunchSizeAllowed(): number {
        return _.defaultTo(_.get(this.schedulerSettings, 'maxPRsBunchSizeAllowed'), 1);
    }

    ngOnInit(): void {
        this.isSpinnerVisible = true;
        this.schedulerSettingsService.schedulerSettings.pipe(takeUntil(this.destroy$)).subscribe(schedulerSettings => {
            this.schedulerSettings = schedulerSettings;
            setTimeout(() => {
                this.isSpinnerVisible = false;
            }, 1500);
        });
    }

    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }

    valueChanged(value: number) {
        const task = this.task;
        if (!task || !task.isCalculation) {
            return;
        }
        this.isSpinnerVisible = true;
        task.setMaxPRsBunchSize(value);
        this.taskService
            .updateTask(task, {
                maxPRsBunchSize: task.maxPRsBunchSize,
                doNotRun: !task.isWorking
            })
            .subscribe(() => {
                this.isSpinnerVisible = false;
            });
    }
}
